import axios from "../axios-auth";
import orginal_axios from "axios";

export const saleService = {
  saveSale,
  printSaleInvoiceById,
  showWindowDialog,
  getUnfinishedCreditSaleList,
  getSaleList,
  returnSale,
  getSalePersonSaleList,
  getSaleDetail
};

function saveSale(sale) {
  if (!sale.id) {
    // new sale
    return axios.post("/auth/sale", sale);
  } else {
    // edit
    return axios.put("/auth/sale", sale);
  }
}

function getSaleList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.payType) {
    params["payType"] = searchParams.payType;
  }
  if (searchParams.customerName) {
    params["customerName"] = searchParams.customerName;
  }
  if (searchParams.customerCode) {
    params["customerCode"] = searchParams.customerCode;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.currencyId) {
    params["currencyId"] = searchParams.currencyId;
  }
  return axios.get("/auth/sales", { params });
}

function getUnfinishedCreditSaleList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.customerName) {
    params["customerName"] = searchParams.customerName;
  }
  if (searchParams.customerCode) {
    params["customerCode"] = searchParams.customerCode;
  }
  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }
  if (searchParams.currencyId) {
    params["currencyId"] = searchParams.currencyId;
  }
  return axios.get("/auth/unfinished-credit-sales", { params });
}

function printSaleInvoiceById(id) {
  return orginal_axios({
    url: axios.defaults.baseURL + "/auth/print-sale-invoice/" + id,
    method: "GET",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/pdf",
      "Content-Type": "application/json"
    }
  }).then(function (response) {
    return new Blob([response.data], { type: "application/pdf" });
  });
}

function showWindowDialog(blob, fileName) {
  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob);
    return;
  }

  // For other browsers: 
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(blob);
  var link = document.createElement(fileName);
  link.href = data;
  link.download = fileName + ".pdf";
  window.open(link.href, fileName, "width=500,height=500");

  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
}

function returnSale(sale) {
  return axios.put("auth/sale-return", sale);
}

function getSalePersonSaleList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.saleNo) {
    params["saleNo"] = searchParams.saleNo;
  }
  if (searchParams.cardNo) {
    params["cardNo"] = searchParams.cardNo;
  }
  if (searchParams.salepersonName) {
    params["salepersonName"] = searchParams.salepersonName;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.counterId) {
    params["counterId"] = searchParams.counterId;
  }
  return axios.get("/auth/saleperson-sales", { params });
}

function getSaleDetail(id) {
  return axios.get("/auth/sale/" + id);
}

